import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiData, UserSymbolLearnMoreClickBiEvent } from '@wix/da-bi/pkg/events';
import { ShopItemType } from '../../../../../../types/shop';

import s from './EmptyStateSubtitleWithLearnMoreLink.scss';

export interface Props {
  shopItemType?: ShopItemType | 'all';
  subtitle: string;
}

const EmptyStateSubtitleWithLearnMoreLink: FC<Props> = ({
  shopItemType,
  subtitle = '',
}) => {
  const { t } = useTranslation();
  const learnMoreLink = t('pages.shop.emptyState.learnMore.url');

  return (
    <span>
      <span>{subtitle}</span>
      <BiLink
        className={s['link']}
        target="_blank"
        href={learnMoreLink}
        biData={BiData<UserSymbolLearnMoreClickBiEvent>({
          evid: 112,
          link_url: learnMoreLink,
          link_name: `empty-shop-${shopItemType}`,
        })}
      >
        {t('pages.shop.emptyState.learnMore')}
      </BiLink>
    </span>
  );
};

EmptyStateSubtitleWithLearnMoreLink.displayName =
  'EmptyStateSubtitleWithLearnMoreLink';

export default EmptyStateSubtitleWithLearnMoreLink;
